import React, { Component } from "react";
import Link from "gatsby-link";
import styled from 'styled-components'
import SEO from '../components/Accessories/SEO/SEO'
import config from '../../data/SiteConfig'
import PostListing from '../components/Posts/PostListing/PostListing'
import '../styles/style.sass';

const NavLink = props => {
  if (!props.test) {
    return <Link to={props.url}>{props.text}</Link>;
  }
    return <span>{props.text}</span>;

};

const IndexPage = ({ data, pathContext }) => {
  const { group, index, first, last } = pathContext;
  const previousUrl = index - 1 == 1 ? "" : (index - 1).toString();
  const nextUrl = (index + 1).toString();

  return (
    <div className="container">
      <PostListContainer>
        <h1 className="tagline">West bound and down, loaded up and truckin'.</h1>
        <Divider />
        <PostListing postEdges={group} />
        <div className="pagination-nav">
          <div className="previousLink nav">
            <NavLink test={first} url={previousUrl} text="< Newer Posts" />
          </div>
          <div className="nextLink nav">
            <NavLink test={last} url={nextUrl} text="Older Posts >" />
          </div>
        </div>
      </PostListContainer>
    </div>
  );
};
export default IndexPage;


const PostListContainer = styled.div`
  margin: 50px 0;

  h2 {
    position: relative;
    font-weight: 400;
  }

  h2:before {
    content: '';
    width: 50px;
    height: 6px;
    position: absolute;
    top: -8px;
    left: 0;
  }

  .post {
    margin-bottom: 70px;
  }

  .tagline {
    width: 100%;
    text-align: center;
    padding: 0 40px;
    color: #adadad;
    font-style: italic;
  }

  .featured-image {
    width: 760px;
    max-width: 100%;
    height: 300px;
    object-fit: cover;
    margin-bottom: 20px;
  }

  .post-link {
    background: none !important;
    padding: 0 !important;
  }

  .pagination-nav {
    font-size: 20px;
    display: flex;
  }

  .pagination-nav .nav {
    width: 50%;
  }

  .nextLink a {
    display: block;
    width: 100%;
    text-align: right;
  }
`
const Divider = styled.div`
  margin: 50px 0;
  border-bottom: 1px solid #e2e2e2;
`


// WEBPACK FOOTER //
// ./src/templates/index.jsx